module.exports = __webpack_public_path__ + "img/panelView_baoSteel_1_3.b50f4af3.png";